import {WhatsappMediaTypesEnum} from '../types/graphqlSchema'
import {
  QUICKTIME_VIDEO_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_AUDIO_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_DOCUMENT_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_IMAGE_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_VIDEO_MAX_FILE_SIZE_BYTES,
} from './consts'

const getWhatsappMediaTypeFromMimeType = (mimeType: string) => {
  if (mimeType.startsWith('text/') || mimeType.startsWith('application/')) {
    return WhatsappMediaTypesEnum.Document
  }
  if (mimeType.startsWith('image/')) {
    return WhatsappMediaTypesEnum.Image
  }
  if (mimeType.startsWith('audio/')) {
    return WhatsappMediaTypesEnum.Audio
  }
  if (mimeType.startsWith('video/')) {
    return WhatsappMediaTypesEnum.Video
  }
  throw `Unsupported mime type ${mimeType}`
}

const getMaxWhatsappBusinessApiFileSizeFromMimeType = (mimeType: string) => ({
  [WhatsappMediaTypesEnum.Audio]: WHATSAPP_BUSINESS_API_AUDIO_MAX_FILE_SIZE_BYTES,
  [WhatsappMediaTypesEnum.Document]: WHATSAPP_BUSINESS_API_DOCUMENT_MAX_FILE_SIZE_BYTES,
  [WhatsappMediaTypesEnum.Image]: WHATSAPP_BUSINESS_API_IMAGE_MAX_FILE_SIZE_BYTES,
  [WhatsappMediaTypesEnum.Video]: WHATSAPP_BUSINESS_API_VIDEO_MAX_FILE_SIZE_BYTES,
}[getWhatsappMediaTypeFromMimeType(mimeType)])

// Separate function for upload validation vs API limits to maintain clear separation
// of concerns. getMaxWhatsappBusinessApiFileSizeFromMimeType() returns actual
// WhatsApp API limits (16MB for video). getMaxUploadFileSizeFromMimeType() returns
// larger limits for files that will be compressed by backend.
const getMaxUploadFileSizeFromMimeType = (
  mimeType: string,
  hasBackendCompression = false
) => {
  // QuickTime videos can be larger since they'll be compressed to fit WhatsApp limits
  if (mimeType === 'video/quicktime' && hasBackendCompression) {
    return QUICKTIME_VIDEO_MAX_FILE_SIZE_BYTES
  }
  // For all other cases, use the standard WhatsApp API limits
  return getMaxWhatsappBusinessApiFileSizeFromMimeType(mimeType)
}

export {getMaxUploadFileSizeFromMimeType, getMaxWhatsappBusinessApiFileSizeFromMimeType}
